module.exports = __webpack_public_path__ + "img/failed-qr.46347b8c.png";